/**
 * Copyright © 2026 Adnuntius AS.
 */
import {ChangeDetectionStrategy, Component, Input, OnInit, signal} from '@angular/core';

import {ReleaseNotesHelper} from '../../../components/util/release-notes-helper.service';
import template from './release-notes-display.component.html';
import {ReleaseNoteCardComponent} from './release-note-card.component';
import {SIMPLE_PAGE_IMPORTS} from './simple-page-imports';

@Component({
  standalone: true,
  imports: [...SIMPLE_PAGE_IMPORTS, ReleaseNoteCardComponent],
  selector: 'adn-release-notes-display',
  template,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ReleaseNotesDisplayComponent implements OnInit {
  @Input() apps: string[];
  @Input() usePrivate = false;
  @Input() urlSlug: string;
  @Input() target = '';

  readonly notes = signal<any[]>([]);
  readonly isRunning = signal(true);

  constructor(private readonly releaseNotesHelper: ReleaseNotesHelper) {
  }

  ngOnInit(): void {
    if (this.urlSlug) {
      const request = this.usePrivate
        ? this.releaseNotesHelper.getFromUrlSlug(this.urlSlug)
        : this.releaseNotesHelper.getPublicFromUrlSlug(this.urlSlug);
      request.then((data: any) => {
        this.finishLoad([data]);
      }).catch(() => {
        this.finishLoad([]);
      });
      return;
    }

    const request = this.usePrivate
      ? this.releaseNotesHelper.query(this.apps, false)
      : this.releaseNotesHelper.queryPublic(this.apps, undefined);
    request.then((data: any[]) => {
      this.finishLoad(data || []);
    }).catch(() => {
      this.finishLoad([]);
    });
  }

  private finishLoad(notes: any[]): void {
    this.notes.set(notes);
    this.isRunning.set(false);
  }
}
